import {getConsolidatedStockList, getSubset} from "./model";
import IAConnector from "../../Api/connector";
import {isObject} from "../../utils/typeCheck";
import {MongoQueryBuilder} from "../../utils/mongoQuery";
import {fetchFilteredTickers} from "../../Api/tickersApi";

export const filterInactiveHoldings = (symbols)=>{
    let aboveZero = {};
    for (let k in symbols){
        if (symbols[k] > 0){
            aboveZero[k] = symbols[k];
        }
    }
    return aboveZero;
}


export const calculateNewSubset = (consolidatedList, cutoffPercent) => {
    return getSubset(consolidatedList.simplifiedObjects, cutoffPercent * 0.01);
};

// In utils/dataProcessing.js
export const fetchAndProcessData = async (etfs, setConsolidatedList, setParents, setError) => {
    if (!etfs || etfs.length === 0) return;
    try {
        let xrayParams;
        if (isObject(etfs)) {
            xrayParams = etfs;
        } else if (etfs[0].hasOwnProperty('symbol')) {
            xrayParams = etfs.map(e => e.symbol);
        }
        if (xrayParams) {
            const xrayData = await IAConnector.xray(xrayParams);
            const processedList = getConsolidatedStockList(xrayData.parents);
            setConsolidatedList(processedList);
            setParents(xrayData.parents);
            setError(null); // Reset error state on successful fetch
        }
    } catch (error) {
        setError(error.toString());
    }
};


/**
 *
 * @param selectedScreen {string} - UUID4 string for the selected screener id if applicable
 * @param screens {Array} - Array of screen objects {id: string, data: {config: Object}
 * @param newSubset {Object} - Object with subset and outset keys containing arrays of stock objects
 * @param consolidatedList {Object} - Object with simplifiedObjects key containing array of stock objects
 * @param dispatch {Function} - Redux dispatch function
 * @returns {Promise<{outset: {symbol: *, cumsum: *, wgt: *, index, sector: *, skew, parents: *}[], subset: *}|*>}
 */
export const applyScreeningFilters = async (selectedScreen,
                                            screens,
                                            newSubset,
                                            consolidatedList,
                                            dispatch) => {
    if (!selectedScreen) return newSubset;

    let appDataObject = screens.find(s => s.id === selectedScreen);
    console.log(appDataObject)
    let symbolList = newSubset.subset.map(s => s.symbol);
    let removed = 0;
    let mongoQuery = MongoQueryBuilder.fromMongoQuery(appDataObject.data.query);
    mongoQuery.inList('symbol', symbolList);
    mongoQuery.projectionFields._id = 0;
    const query = mongoQuery.toMongoQuery();
    console.log(query)

    try {
        const filteredResponse = await dispatch(fetchFilteredTickers(query)).unwrap();
        console.log('filteredResponse', filteredResponse)
        let screenedSubset = filteredResponse.map(ticker => ({
            ...consolidatedList.simplifiedObjects.find(s => s.symbol === ticker.symbol),
            ...ticker,
        })).filter(Boolean); // Filter out undefined results
        removed = newSubset.subset.length - screenedSubset.length;
        return {
            subset: screenedSubset,
            outset: consolidatedList.simplifiedObjects.filter(s => !screenedSubset.find(ss => ss.symbol === s.symbol)),
            removed
        };
    } catch (error) {
        throw error; // Rethrow or handle as needed
    }
};


/**
 *
 * @param subset {Array[object]} containing 'symbol' and 'sector' fields
 * @param blacklist {Object[str, Array[str]]} containing fields 'sectors' and 'symbols' with any sectors or symbols to exclude
 */
export const applyBlacklist = (subset, blacklist) => {
    if (!blacklist) return {
        subset, removed: 0
    };
    const filteredSubset = subset.filter(item =>
        !blacklist.tickers.includes(item.symbol) &&
        !blacklist.sectors.includes(item.sector)
    );
    return {
        subset: filteredSubset,
        removed: subset.length - filteredSubset.length
    };
};